import React, {useEffect, useReducer, useRef, useState} from 'react';
import Header from "../../Layouts/Header/Header";
import SubMainContainer from "../../UI/SubMainContainer";
import SideBar from "../../Layouts/SideBar/SideBar";
import Navigation from "./Navigation";
import MainContainer from "../../UI/MainContainer";
import EmployeeData from "../../Settings/Employee/EmployeeData";
import {Link} from "react-router-dom";
import AddEmployee from "../../Settings/Employee/AddEmployee";
import EditEmployee from "../../Settings/Employee/EditEmployee";
import useAxiosIntercept from "../../../hooks/useAxiosIntercept";
import useAuth from "../../../hooks/useAuth";
import DeleteEmployee from "../../Settings/Employee/DeleteEmployee";

function Employee(props) {
    const axiosPrivate = useAxiosIntercept();
    const [users, setUsers] = useState([]);
    // const [state, dispatch] = useReducer(reducer, initialState);
    const [showPop,setShowPop]= useState(false);
    const [showPopEditProfile, setShowPopEditProfie] = useState(false);
    const [showPopDeleteProfile, setShowPopDeleteProfie] = useState(false);
    const [empData, setEmpData] = useState('');
    const [empDelData, setEmpDelData] = useState('');
    const ref = useRef(true);
    const {auth} = useAuth();
    const [message, setMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    // const [action, setAction] = useState();

    let deleteEmployee = async (userData) => {
        if(auth.userIsRoot == 'Y' || auth.userIsRoot == 'y'){
            setShowPopDeleteProfie(true);
            setEmpDelData(userData);
        }
        else{
            setMessage("You do not have privilege to perform this action");
            setTimeout(()=>{
                setMessage("");
            },3000);
        }

    }

    const editEmployee = (data) =>{
        if(auth.userIsRoot == 'Y' || auth.userIsRoot == 'y'){
            setShowPopEditProfie(true);
            // setAction("edit");
            setEmpData(data);
        }
        else{
            setMessage("You do not have privilege to perform this action");
            setTimeout(()=>{
                setMessage("");
            },3000)
        }

    }

    const closeEditpop = (value) => {
           // setAction("");
        if(value){
            getUsers();
        }
           setShowPopEditProfie(false);
    }

    const closeDeletepop = (value) => {
           // setAction("");
        if(value){
            getUsers();
        }
           setShowPopDeleteProfie(false);
    }

    const popupAction = (isSubmitted) =>{
        if(isSubmitted){
            getUsers();
        }
        setShowPop((prev) =>{
            return !prev});
    }

    const getUsers = async () => {
        let URL = process.env.REACT_APP_USER_INFO_URL + '&user_type='+ "P";
        try {
            setIsLoading(true);
            const response = await axiosPrivate.get(URL);
            setIsLoading(false);
            if(response?.status == 200){
                if(response?.data?.status == 200){
                    if(response?.data?.response?.data?.user_info){
                        setUsers(response?.data?.response?.data?.user_info);
                    }
                }
                else{
                    if(response?.data?.response?.errors){
                        console.log(response?.data?.response?.errors[0].message);
                    }
                }
            }
            else{
                console.log(response?.message);
            }
            // setUsers(response?.data?.response?.data?.user_info);
            // setTotalRecords(response?.data?.response?.data?.total_records);
        } catch (err) {
            console.log(err);
        }
    };
    useEffect(()=>{
        if(ref.current){
            ref.current = false;
            getUsers();

        }
    }, [])
    return (
        <>
            {/*<div id="portal-root"></div>*/}
            <MainContainer>
                <Header />
                <SubMainContainer>
                    <SideBar />
                    <div className="rightCol">
                        <div className="contentContainer">
                            <h2>Settings</h2>
                            <div className="subContent">
                                <Navigation/>
                                <div className="subHeading mt-24 mb-16">
                                    <h3>Employees</h3>
                                    {(auth.userIsRoot == 'Y' || auth.userIsRoot == 'y') && <Link className="btn prim open_model" onClick={popupAction} >Add new employee</Link>}
                                    {/*{showPop ? createPortal(<Form close = {popupAction}/>,document.body) : null}*/}
                                    {showPop ? <AddEmployee close={(value)=>popupAction(value)} /> : null}
                                </div>
                                {!isLoading ? <EmployeeData users={users} editEmployee={(data)=>editEmployee(data)} delete={(data)=>{deleteEmployee(data)}}/> : <p>Loading...</p>}
                                    {showPopEditProfile ? <EditEmployee close={(value)=>closeEditpop(value)} data={empData}/> : null}
                                    {showPopDeleteProfile ? <DeleteEmployee close={(value)=>closeDeletepop(value)} data={empDelData}/> : null}
                            </div>
                        </div>
                    </div>
                    {/*<h2>{auth.userIsRoot}</h2>*/}



                </SubMainContainer>
            </MainContainer>
        </>

    );
}

export default Employee;